module.exports = __webpack_public_path__ + "01_hige_black.894bb9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/01_hige_black.png
// module id = Ohso
// module chunks = 0